import React from "react";
import { PROGRAMATE } from "../../../config/images";
const Programate = ({fontSize = "text-[18px]"}) => {

    return(
      <div className={`flex justify-center gap-1 sm:gap-2 font-rubikregular text-white ${fontSize}`}>
          <p>Crafted with </p>
          <img src={PROGRAMATE.HEART} />
          <p>by <a href="https://programate.pe/"  className="text-white underline cursor-pointer"  target="_blank">Prográmate</a></p>
        </div>
    )
}

export default Programate;
